// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__8plp3","errorLogs":"styles_errorLogs__23OS7"};